var dict = {
  'pl-PL': {
    dictDefaultMessage: 'Upuść pliki tutaj',
    dictFallbackMessage: 'Twoja przeglądarka nie obsługuje wgrywania plików metodą drag\'n\'drop',
    dictFallbackText: 'Użyj formularza poniżej.',
    dictFileTooBig: 'Plik jest zbyt duży ({{filesize}}MB). Maksymalny dozwolony rozmiar: {{maxFilesize}}MB.',
    dictInvalidFileType: 'Nie możesz wgrywać plików tego typu.',
    dictResponseError: 'Serwer odpowiedział kodem {{statusCode}}.',
    dictCancelUpload: 'Anuluj',
    dictUploadCanceled: 'Anulowane.',
    dictCancelUploadConfirmation: 'Czy na pewno chcesz anulować?',
    dictRemoveFile: 'Usuń plik',
    dictRemoveFileConfirmation: null,
    dictMaxFilesExceeded: 'Limit ilości plików został osiągnięty.',
    dictUploadingHText: 'Wgrywanie PDF',
    dictUploadingText: '{0} Mb z {1} Mb',
    dictPreaperingText: 'Przygotowywanie pliku...',
  },
  'default': {
    dictDefaultMessage: 'Drop files here',
    dictFallbackMessage: 'Your browser does not support drag and drop functionality.',
    dictFallbackText: 'Use form belowe.',
    dictFileTooBig: 'File is too big ({{filesize}}MB). Maximum allowed file size: {{maxFilesize}}MB.',
    dictInvalidFileType: 'Invalid file type.',
    dictResponseError: 'Server responded with {{statusCode}}.',
    dictCancelUpload: 'Cancel',
    dictUploadCanceled: 'Canceled.',
    dictCancelUploadConfirmation: 'Do you really want to cancel?',
    dictRemoveFile: 'Remove file',
    dictRemoveFileConfirmation: null,
    dictMaxFilesExceeded: 'Maximum amount of allowed files has been reached.',
    dictUploadingHText: 'Uploading PDF',
    dictUploadingText: '{0} Mb of {1} Mb',
    dictPreaperingText: 'Preparing the file...',
  }
};

var lang = document.documentElement.lang;
if (!dict[lang]) {
    lang = 'default';
}

Dropzone.options.issueUpload = {
    maxFilesize: 500,
    createImageThumbnails: false,
    maxFiles: 1,
    acceptedFiles: '.pdf',
    timeout: 0,
    previewTemplate: ' <div class="dz-preview dz-file-preview"><span class="dz-progress-percent"></span><div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div><span class="dz-progress-header"></span><span class="dz-progress-text"></span></div>',
    headers: {
        'Cache-Control': null,
        'X-Requested-With': null
    },

    dictDefaultMessage: dict[lang].dictDefaultMessage,
    dictFallbackMessage: dict[lang].dictFallbackMessage,
    dictFallbackText: dict[lang].dictFallbackText,
    dictFileTooBig: dict[lang].dictFileTooBig,
    dictInvalidFileType: dict[lang].dictInvalidFileType,
    dictResponseError: dict[lang].dictResponseError,
    dictCancelUpload: dict[lang].dictCancelUpload,
    dictUploadCanceled: dict[lang].dictUploadCanceled,
    dictCancelUploadConfirmation: dict[lang].dictCancelUploadConfirmation,
    dictRemoveFile: dict[lang].dictRemoveFile,
    dictRemoveFileConfirmation: null,
    dictMaxFilesExceeded: dict[lang].dictMaxFilesExceeded,
    dictFileSizeUnits: { tb: "TB", gb: "GB", mb: "MB", kb: "KB", b: "b" },

    init: function () {
        this.on('addedfile', function (file) {
            document.getElementById('issue-upload-error').innerHTML = '';
  
            var textElement = file.previewElement.querySelector('.dz-progress-text');
            var text = dict[lang].dictUploadingText
                                       .replace('{0}', '0.00')
                                       .replace('{1}', (file.size / 1024 / 1024).toFixed(2))
            textElement.textContent = text;
            
            var percentElement = file.previewElement.querySelector('.dz-progress-percent');
            var percent = 0 + '%';
            percentElement.textContent = percent;
            
            var textHeader = file.previewElement.querySelector('.dz-progress-header');
            textHeader.textContent = dict[lang].dictUploadingHText;
            
            
        });

        this.on('error', function (file, message) {
            this.removeFile(file);
            if (file.status == 'error') {
                document.getElementById('issue-upload-error').innerHTML = message;
            }
        });

        this.on('maxfilesexceeded', function (file) {
            this.removeAllFiles(true);
        });

        this.on('success', function (file, response) {
          
            var name = response.name;
            var url = this.element.getAttribute('data-redirect-url') + '/' + encodeURIComponent(name);
            window.location.assign(url);
        });
        
        this.on('uploadprogress', function (file, progress, bytesSent) {
 
            var textElement = file.previewElement.querySelector('.dz-progress-text');
            var text = dict[lang].dictUploadingText
                                       .replace('{0}', (bytesSent / 1024 / 1024).toFixed(2))
                                       .replace('{1}', (file.size / 1024 / 1024).toFixed(2))
            textElement.textContent = text;
            
            var percentElement = file.previewElement.querySelector('.dz-progress-percent');
            var percent = progress.toFixed(0) + '%';
            percentElement.textContent = percent;
        });
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/component.js